import FluxUtils from 'flux/utils';
import { History, Location } from 'history';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { StaticContext } from 'react-router';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import WebAppsStore from 'sharedreact/stores/WebAppsStore';
import UrlQuery from 'sharedreact/utils/UrlQuery';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import ClientAppsPage from 'workspaces/launcher/components/clientapps/ClientAppsPage';
import asFunctional from 'sharedreact/components/asFunctional';
import LocationState from 'sharedreact/utils/LocationState';


type Props = RouteComponentProps<{}, StaticContext, LocationState> & {
};

type State = ConstructorParameters<typeof ClientAppsPage>[0];

function getStores () {
  return [
    SettingsStore,
    WebAppsStore
  ];
}

function handleSelectTab (tab: string, history: History<any>, location: Location<LocationState>): void {
  let search: {[key: string]: string} = UrlQuery.parse(location.search);
  search.tab = tab;

  const searchString: string = UrlQuery.stringify(search);

  history.replace(location.pathname + searchString);
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  const search: {[key: string]: string} = UrlQuery.parse(props.location.search);
  const tab: string = search.tab || '';

  return {
    activeTab: tab,
    language: SettingsStore.getLanguage(),
    onSelectTab: (tab: string) => handleSelectTab(tab, props.history, props.location)
  };
}

export default withRouter(
  FluxUtils.Container.createFunctional(
    asFunctional(ClientAppsPage),
    getStores,
    calculateState,
    { withProps: true }
  )
);
